import type { Segment, VoteCountsAnswer, VoterCountsAnswer, VoterDataDetailRequest } from '@signalvote/shared';
import type { ApiClient } from '../client';

type Abortable = Pick<RequestInit, 'signal'>;

export function createAbortableVoterDataCounts(client: ApiClient) {
  const post = <T>(endpoint: string, body: unknown, init?: Abortable) =>
    client.request<T>(endpoint, { ...init, method: 'POST', body: JSON.stringify(body) });
  return {
    getCounts: (body: Segment, init?: Abortable) => post<VoterCountsAnswer>('/api/voter-data/counts', body, init),
    getRuleOptions: (body: VoterDataDetailRequest, init?: Abortable) =>
      post<VoterCountsAnswer>('/api/voter-data/counts/rule-options', body, init),
    getVoteCounts: (body: VoterDataDetailRequest, init?: Abortable) =>
      post<VoteCountsAnswer>('/api/voter-data/counts/votes', body, init),
  };
}
